
module dgUtils {

    export class UiService {
        public static recalculateViewHeight (windowHeight: number) {

            let topAndBottomElementsHeight = angular.element('.navbar-header').first().outerHeight(true)
                + (angular.element('.view-heading').first().outerHeight(true) || 102)
                + angular.element('.app-footer').first().outerHeight(true);
            let a = angular.element('.navbar-header').first().outerHeight(true);
            let b = angular.element('.view-heading').first().outerHeight(true)
            let c = angular.element('.app-footer').first().outerHeight(true);

            return windowHeight - topAndBottomElementsHeight - 5;
        }


        //Old implementation
        public getLinkByProperty(property: string, phaseName: string, queryResult: any) {
            for (let i = 0; i < queryResult.items.length; i += 1) {
                //Quick hack, server should return the objects in the same structure
                if (queryResult.items[i][property].id == phaseName || queryResult.items[i][property].id == phaseName) {
                    return queryResult.items[i].dgMeta.links.viewEvents;
                }
            }
        }

        public getLinkByPropertyAndLevel(property: string, clickedProperty: string, clickedLevel: string , queryResult: any) {
            for (let i = 0; i < queryResult.items.length; i += 1) {
                //Quick hack, server should return the objects in the same structure
                if (queryResult.items[i][property] == clickedProperty || queryResult.items[i][property].id == clickedProperty) {
                    return queryResult.items[i].dgMeta.properties[clickedLevel.toLowerCase() + 'Count'].links.viewEvents;
                }
            }
        }
    }

    angular.module('dgUtils')
        .service('uiService', UiService);
}

